import { render, staticRenderFns } from "./OrgWorkSpaceView.vue?vue&type=template&id=017ca5dd&scoped=true&"
import script from "./OrgWorkSpaceView.vue?vue&type=script&lang=js&"
export * from "./OrgWorkSpaceView.vue?vue&type=script&lang=js&"
import style0 from "./OrgWorkSpaceView.vue?vue&type=style&index=0&id=017ca5dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ca5dd",
  null
  
)

export default component.exports